// extracted by mini-css-extract-plugin
module.exports = {"title":"sorting-mobile_title__24Rqf","item":"sorting-mobile_item__2Epqm"};